// extracted by mini-css-extract-plugin
export default {"name":"BuyerInfo_name__dlkOT","nickname":"BuyerInfo_nickname__uWjSf","label":"BuyerInfo_label__U0g9P","number":"BuyerInfo_number__E5qtZ"};